export default __webpack_public_path__ + "static/media/hero.cf5d52c0.webp";